module.exports = __webpack_public_path__ + "static/media/advisory.df988690.svg";